<template>
  <div
    id="mentor-matching-success-notification"
    class="tw-fixed tw-inset-x-0 tw-top-0 tw-z-[999] tw-mx-auto tw-w-full tw-max-w-[450px] tw-px-2"
  >
    <div
      class="tw-mt-2 tw-flex tw-items-center tw-justify-between tw-rounded-xl tw-border tw-border-success-200 tw-bg-success-50 tw-p-3 tw-text-sm tw-font-semibold tw-text-success-500 tw-shadow-md"
    >
      <div class="tw-flex tw-items-center sm:tw-space-x-3">
        <BaseIcon
          name="lightning"
          class="tw-hidden tw-h-4 tw-w-4 tw-shrink-0 sm:tw-block"
        />
        <span class="tw-hidden sm:tw-block">Mentor matching complete</span>
        <span class="tw-block sm:tw-hidden">Matching complete</span>
      </div>
      <div class="tw-flex tw-items-center tw-space-x-3">
        <BaseButton
          @click="closeNotification"
          color="outline-green"
          size="small"
          class="!tw-bg-transparent"
          is-inertia-link
          :href="notificationsStore.mentorMatchingNotification.matchingUrl"
        >
          See mentors
        </BaseButton>
        <button @click="closeNotification">
          <BaseIcon name="e-remove-1" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useNotificationsContainerPosition } from '@/shared/composables/useNotificationsContainerPosition.ts'
import BaseIcon from '@/shared/components/BaseIcon.vue'
import BaseButton from '@/shared/components/BaseButton.vue'
import { useNotificationsStore } from '@/shared/stores/notifications.js'

useNotificationsContainerPosition('mentor-matching-success-notification')

const notificationsStore = useNotificationsStore()

const closeNotification = () => {
  notificationsStore.mentorMatchingNotification.isVisible = false
  notificationsStore.mentorMatchingNotification.matchingUrl = null
}
</script>
